const routePaths = {
  activation: '/activation',
  home: '/',
  firstTimeLogin: '/firsttimelogin',
  firstTimeLoginConfirmation: '/firsttimelogin/confirmation',
  logout: '/logout',
  notFound: '/not-found',
  recoverUserId: '/recoveruserid',
  resetPassword: '/resetpassword',
  registration: '/registration',
  registerChildAccount: '/registerchildaccount',
  lostCardConfirmation: '/lostcardconfirmation',
  updatePassword: '/updatepassword',
  summary: '/summary',
  makePayment: '/makepayment',
  viewPayment: '/viewpayment',
  invoice: '/invoice',
  credit: '/credit',
  cliQuestionnaire: '/cli-questionnaire',
  editBusinessInfo: '/editbusinessinfo',
  manageBuyers: '/managebuyers',
  managePayment: '/managepayment',
  increaseCreditLine: '/increasecreditline',
  taxForms: '/taxforms',
  userGuide: '/userguide',
  closeAccount: '/closeaccount',
  editJobName: '/editjobname',
  statement: '/statement',
  editUser: '/edituser',
  emailStatement: '/emailstatement',
  manageUser: '/manageuser',
  manageLinkedAccounts: '/managelinkedaccounts',
  invoiceBillPay: '/invoicebillpay',
  ibpStatus: '/ibpstatus',
  contactUs: '/contactus',
  manageChildAccount: '/managechildaccount',
  videoGallery: '/videogallery',
  transactions: '/transactions',
  requestBuyerCards: '/requestbuyercards',
  lostCard: '/lostcard',
  sessionExpired: '/sessionexpired',
  error: '/error',
  companyProfile: '/companyprofile'
}

export default routePaths
